import { isLv95, lv95ToWgs84 } from './lv95';

export type ParsedInput =
  | { kind: 'coords'; lat: number; lon: number }
  | { kind: 'lv95'; e: number; n: number; lat: number; lon: number }
  | { kind: 'egid'; egid: string }
  | { kind: 'text'; text: string }
  | { kind: 'empty' }
  | { kind: 'invalid'; reason: string };

const NUM = String.raw`[-+]?\d+(?:[.]\d+)?`;
const PAIR = new RegExp(`^\\s*(${NUM})\\s*(?:[,;/]\\s*|\\s+)(${NUM})\\s*$`);

/**
 * Erkennt Koordinaten (WGS84 dezimal oder LV95), EGID und Freitext.
 * Tausendertrennzeichen in LV95 (Apostroph, Leerzeichen) werden entfernt.
 */
export function parseInput(raw: string): ParsedInput {
  const s = raw.trim();
  if (!s) return { kind: 'empty' };
  const egidMatch = /^egid\s*:?\s*(\d{1,9})$/i.exec(s);
  if (egidMatch) return { kind: 'egid', egid: egidMatch[1] };
  if (/^egid\b/i.test(s)) return { kind: 'invalid', reason: 'EGID besteht aus 1 bis 9 Ziffern, z. B. «EGID 3169989».' };
  if (/^\d{5,9}$/.test(s)) return { kind: 'egid', egid: s };

  const compact = s.replace(/(\d)['’ ](?=\d{3}(?:\D|$))/g, '$1');
  const m = PAIR.exec(compact);
  if (m) {
    const a = Number(m[1]);
    const b = Number(m[2]);
    if (Math.abs(a) > 1000 || Math.abs(b) > 1000) {
      if (isLv95(a, b)) return { kind: 'lv95', e: a, n: b, ...lv95ToWgs84(a, b) };
      if (isLv95(b, a)) return { kind: 'lv95', e: b, n: a, ...lv95ToWgs84(b, a) };
      return { kind: 'invalid', reason: 'Die Zahlen sind weder gültige WGS84-Koordinaten noch LV95-Koordinaten in der Schweiz (E 2’480’000–2’840’000, N 1’070’000–1’300’000).' };
    }
    if (a < -90 || a > 90) return { kind: 'invalid', reason: 'Breite muss zwischen −90 und 90 liegen (Reihenfolge: Breite, Länge).' };
    if (b < -180 || b > 180) return { kind: 'invalid', reason: 'Länge muss zwischen −180 und 180 liegen.' };
    return { kind: 'coords', lat: a, lon: b };
  }
  if (s.length < 2) return { kind: 'invalid', reason: 'Bitte mindestens zwei Zeichen eingeben.' };
  if (s.length > 200) return { kind: 'invalid', reason: 'Eingabe zu lang.' };
  return { kind: 'text', text: s };
}
